import React from "react";

import Icons from "./../../../utils/import.icons";

interface Props {
  isProyecto: boolean;
  isSidebarHidden: boolean;
  proyecto: any;
  secondaryBtnSelected: any;
  handleShowProyecto: any;
}

interface State {}

interface Info {
  Icons?: any;
}

class ProyectoSidebar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  handleCreateButtonsStructure = () => {
    const ameniadesIcons: Info = { Icons };
    return this.props.proyecto.map((amenidad: any, index: number) =>
      amenidad.Nombre !== "General View" ? (
        <React.Fragment key={(index + 2) * 2}>
          <div
            className={
              this.props.secondaryBtnSelected === amenidad.Nombre
                ? "btn-sidebar-amenidades selected"
                : this.props.isSidebarHidden
                ? "btn-sidebar-amenidades-collapsed"
                : "btn-sidebar-amenidades"
            }
            key={index}
            onClick={() => {
              this.props.handleShowProyecto(
                amenidad.Nombre,
                ameniadesIcons.Icons[amenidad.Nombre + "2"],
                amenidad
              );
            }}
          >
            <img
              src={
                ameniadesIcons.Icons[
                  this.props.secondaryBtnSelected === amenidad.Nombre
                    ? amenidad.Nombre + "2"
                    : amenidad.Nombre
                ]
              }
              alt=""
            />
            <div>{amenidad.Nombre}</div>
          </div>
          <hr className="secondary-bar-hr" key={(index + 1) * 2} />
        </React.Fragment>
      ) : null
    );
  };

  render(): React.ReactNode {
    const ameniadesIcons: Info = { Icons };
    return (
      <div
        className={
          !this.props.isSidebarHidden && this.props.isProyecto
            ? "amenidades-sidebar"
            : "amenidades-collapsed"
        }
      >
        <div
          className={
            this.props.secondaryBtnSelected === "planimetria"
              ? "btn-sidebar-amenidades selected"
              : this.props.isSidebarHidden
              ? "btn-sidebar-amenidades-collapsed"
              : "btn-sidebar-amenidades"
          }
          onClick={() => {
            this.props.handleShowProyecto(
              "planimetria"
            );
          }}
        >
          <img
            src={
              ameniadesIcons.Icons[
                this.props.secondaryBtnSelected === "planimetria"
                  ? "planimetria2"
                  : "planimetria"
              ]
            }
            alt=""
          />
          <div>Planimetria</div>
        </div>
        <hr className="secondary-bar-hr" />
        <div
          className={
            this.props.secondaryBtnSelected === "presentacion"
              ? "btn-sidebar-amenidades selected"
              : this.props.isSidebarHidden
              ? "btn-sidebar-amenidades-collapsed"
              : "btn-sidebar-amenidades"
          }
          onClick={() => {
            this.props.handleShowProyecto(
              "presentacion",
            );
          }}
        >
          <img
            src={
              ameniadesIcons.Icons[
                this.props.secondaryBtnSelected === "presentacion"
                  ? "presentacion2"
                  : "presentacion"
              ]
            }
            alt=""
          />
          <div>Presentación</div>
        </div>
        <hr className="secondary-bar-hr" />
        <div
          className={
            this.props.secondaryBtnSelected === "videos"
              ? "btn-sidebar-amenidades selected"
              : this.props.isSidebarHidden
              ? "btn-sidebar-amenidades-collapsed"
              : "btn-sidebar-amenidades"
          }
          onClick={() => {
            this.props.handleShowProyecto(
              "videos",
            );
          }}
        >
          <img
            src={
              ameniadesIcons.Icons[
                this.props.secondaryBtnSelected === "videos"
                  ? "videos2"
                  : "videos"
              ]
            }
            alt=""
          />
          <div>Videos</div>
        </div>
        <hr className="secondary-bar-hr" />
        <a href="https://umbra3d.studio/maquetas/mas-developers/casa-ambar/BookCasaAmbar.pdf" target="_blank" rel="noopener noreferrer">
        <div
          className={
            this.props.secondaryBtnSelected === "brochure"
              ? "btn-sidebar-amenidades selected"
              : this.props.isSidebarHidden
              ? "btn-sidebar-amenidades-collapsed"
              : "btn-sidebar-amenidades"
          }
          onClick={() => {
            this.props.handleShowProyecto(
              "brochure"
            );
          }}
        >
        
          <img
            src={
              ameniadesIcons.Icons[
                this.props.secondaryBtnSelected === "brochure"
                  ? "brochure2"
                  : "brochure"
              ]
            }
            alt=""
          />
          <div>Brochure</div>
          
        </div>
        </a> 
        <hr className="secondary-bar-hr" />
        <div
          className={
            this.props.secondaryBtnSelected === "contacto"
              ? "btn-sidebar-amenidades selected"
              : this.props.isSidebarHidden
              ? "btn-sidebar-amenidades-collapsed"
              : "btn-sidebar-amenidades"
          }
          onClick={() => {
            this.props.handleShowProyecto(
              "contacto"
            );
          }}
        >
        <a href={"https://wa.me/573177518216"} target="_blank" rel="noopener noreferrer">
          <img
            src={
              ameniadesIcons.Icons[
                this.props.secondaryBtnSelected === "contacto"
                  ? "contacto2"
                  : "contacto"
              ]
            }
            alt=""
          />
          <div>Contacto</div>
          </a>
        </div>
        <hr className="secondary-bar-hr" />
      </div>
    );
  }
}

export default ProyectoSidebar;
